window.addEventListener("load", () => {
  if (typeof AOS !== "undefined" && AOS && typeof AOS.init === "function") {
    AOS.init({});
  }
});

(() => {
  "use strict";

  const createMobileMenu = (nav, header) => {
    const mobileMenu = document.createElement("div");
    mobileMenu.className = "site-header__mobile-menu";

    const navClone = nav.cloneNode(true);
    navClone.className = "site-header__nav";
    mobileMenu.appendChild(navClone);

    const cta = header.querySelector(".site-header__cta");
    if (cta) {
      const ctaClone = cta.cloneNode(true);
      mobileMenu.appendChild(ctaClone);
    }

    const headerMain = header.querySelector(".site-header__main");
    if (headerMain) {
      headerMain.appendChild(mobileMenu);
    }

    return mobileMenu;
  };

  const handleMobileSubmenus = (mobileMenu) => {
    const parentItems = mobileMenu.querySelectorAll(
      ".has-children, .menu-item-has-children",
    );

    parentItems.forEach((item) => {
      const link = item.querySelector("a");
      const submenu = item.querySelector(".sub-menu");

      if (!link || !submenu) return;

      const toggle = document.createElement("button");
      toggle.className = "submenu-toggle";
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Toggle submenu");
      toggle.innerHTML = '<span class="submenu-toggle-icon">+</span>';

      if (link.parentNode) {
        link.parentNode.insertBefore(toggle, link.nextSibling);
      }

      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isExpanded = toggle.getAttribute("aria-expanded") === "true";

        mobileMenu.querySelectorAll(".submenu-toggle").forEach((otherToggle) => {
          if (otherToggle === toggle) return;

          otherToggle.setAttribute("aria-expanded", "false");

          const otherSubmenu = otherToggle.parentNode
            ? otherToggle.parentNode.querySelector(".sub-menu")
            : null;
          if (otherSubmenu) otherSubmenu.classList.remove("is-open");

          const otherIcon = otherToggle.querySelector(".submenu-toggle-icon");
          if (otherIcon) otherIcon.textContent = "+";
        });

        toggle.setAttribute("aria-expanded", String(!isExpanded));
        submenu.classList.toggle("is-open");

        const icon = toggle.querySelector(".submenu-toggle-icon");
        if (icon) icon.textContent = !isExpanded ? "−" : "+";
      });
    });
  };

  /**
   * Close mobile menu helper
   */
  const closeMobileMenu = (mobileToggle, mobileMenu, header) => {
    mobileToggle.setAttribute("aria-expanded", "false");
    mobileMenu.classList.remove("is-open");
    header.classList.remove("is-open");
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  };

  /**
   * Handle anchor links
   * - Jeśli id istnieje na bieżącej stronie → płynny scroll
   * - Jeśli id nie istnieje → przekierowanie na stronę główną z /#id (przeglądarka obsłuży scroll)
   * - Linki bez # (np. /faq) → normalna nawigacja, bez preventDefault
   * - Na mobile zawsze zamyka menu przed akcją
   */
  const handleAnchorLinks = (mobileToggle, mobileMenu, header) => {
    document.addEventListener("click", (e) => {
      const link = e.target.closest('a[href^="#"], a[href*="/#"]');
      if (!link) return;

      const href = link.getAttribute("href");

      // Wyciągnij targetId
      const targetId = href.includes("/#")
        ? href.split("/#")[1]
        : href.slice(1);

      // Brak id (np. href="#") - nic nie rób
      if (!targetId) {
        e.preventDefault();
        return;
      }

      const target = document.getElementById(targetId);

      if (target) {
        // Id istnieje na tej stronie - płynny scroll
        e.preventDefault();

        if (mobileMenu.classList.contains("is-open")) {
          closeMobileMenu(mobileToggle, mobileMenu, header);
        }

        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 300);
      } else {
        // Id nie istnieje na tej stronie - przekieruj na stronę główną z #id
        // Nie robimy preventDefault - pozwalamy przeglądarce nawigować
        // Ale najpierw zamykamy menu
        if (mobileMenu.classList.contains("is-open")) {
          closeMobileMenu(mobileToggle, mobileMenu, header);
        }

        // Ustaw href na format /#id i pozwól przeglądarce przejść
        window.location.href = "/#" + targetId;
      }
    });
  };

  const initSiteHeader = () => {
    const header = document.querySelector(".site-header");
    if (!header) return;

    const mobileToggle = header.querySelector(".site-header__mobile-toggle");
    const nav = header.querySelector(".site-header__nav");
    if (!mobileToggle || !nav) return;

    const mobileMenu = createMobileMenu(nav, header);

    mobileToggle.addEventListener("click", () => {
      const isExpanded = mobileToggle.getAttribute("aria-expanded") === "true";

      mobileToggle.setAttribute("aria-expanded", String(!isExpanded));
      mobileMenu.classList.toggle("is-open");
      header.classList.toggle("is-open");
      document.body.style.overflow = !isExpanded ? "hidden" : "";
      document.documentElement.style.overflow = !isExpanded ? "hidden" : "";
    });

    handleMobileSubmenus(mobileMenu);

    // Anchor links - event delegation na document, obsługuje też clonowane linki
    handleAnchorLinks(mobileToggle, mobileMenu, header);

    window.addEventListener("resize", () => {
      if (window.innerWidth >= 992) {
        closeMobileMenu(mobileToggle, mobileMenu, header);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && mobileMenu.classList.contains("is-open")) {
        closeMobileMenu(mobileToggle, mobileMenu, header);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSiteHeader);
  } else {
    initSiteHeader();
  }
})();
